var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[(_vm.size === 'base')?_c('hr',{staticClass:"short-section-line"}):_vm._e(),_vm._v(" "),(_vm.size === 'base')?_c('h2',[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.size === 'small')?_c('h3',[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.size === 'smaller')?_c('h4',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }